import { Stack, StackProps } from '@mui/material';
import React from 'react';

import { EstatePage_EntityFragment } from '@/modules/estate/graphql/EstatePageData.generated';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { EntityStage } from '@/types/schema';

import { ViewHoldingsGroupPresentationButton } from '../ViewHoldingsGroupButton/ViewHoldingsGroupButton';
import { useNavigateToGRATPageByStage } from './useNavigateToGRATPageByStage';

export interface DraftGRATActionsProps extends Omit<StackProps, 'direction'> {
  entity: EstatePage_EntityFragment;
  isHovered?: boolean;
}

export function DraftGRATActions({
  entity,
  sx,
  ...stackProps
}: DraftGRATActionsProps) {
  const { householdId } = useHouseholdDetailsContext();
  const navigateToGRATPageByStage = useNavigateToGRATPageByStage();

  const handleClick = (event: React.MouseEvent) => {
    if (!householdId) return;
    event.stopPropagation();
    navigateToGRATPageByStage(entity.stage, entity.id);
  };

  const text = (() => {
    switch (entity.stage) {
      case EntityStage.ReadyForProposal:
      // falls through
      case EntityStage.Draft:
        return 'Design';
      case EntityStage.Implementation:
        return 'Implementation';
      default:
        // unexpected, but stranger things have happened
        return 'Overview';
    }
  })();

  return (
    <Stack direction="row" {...stackProps} spacing={1}>
      <ViewHoldingsGroupPresentationButton onClick={handleClick}>
        {text}
      </ViewHoldingsGroupPresentationButton>
    </Stack>
  );
}
